"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasXLogo = void 0;
const utils_1 = require("../utils");
function hasXLogo(info) {
    return utils_1.isDictionary(info['x-logo']);
}
exports.hasXLogo = hasXLogo;
//# sourceMappingURL=guards.js.map